import { PnlQueryRequest, PnlReportConfig } from 'src/components/star-grid/starGridTypes';

export interface PnlReportSelection {
  readonly asOfTimestamp?: string;
  readonly groupBy: readonly string[];
  readonly filters: Record<string, readonly string[]>;
}

export const defaultReportSelection = (definition: PnlReportConfig): PnlReportSelection => ({
  groupBy: definition.default_group_by?.length ? definition.default_group_by : definition.group_by_dimensions.slice(0, 1),
  filters: definition.default_filters ?? {}
});

/** The backend adds scenario_id/month to the projection; group_by contains row dimensions only. */
export const pnlReportRequest = (definition: PnlReportConfig, selection: PnlReportSelection): PnlQueryRequest => ({
  ...(selection.asOfTimestamp ? { as_of_timestamp: selection.asOfTimestamp } : {}),
  group_by: [...selection.groupBy],
  filters: Object.fromEntries(Object.entries(selection.filters).map(([field, values]) => [field, [...values]])),
  scenarios: definition.scenarios,
  variance_pairs: definition.variance_pairs,
  measure: definition.measure
});

export const currentReportSelection = (selection: PnlReportSelection): PnlReportSelection => ({
  groupBy: selection.groupBy,
  filters: selection.filters,
  asOfTimestamp: selection.asOfTimestamp
});
